
import { MUTATIONS } from '@/store/mutations';
import { GETTERS } from '@/store/getters';
import NavigationFooter from '@/core/components/NavigationFooter.vue';
import BookingTime from '@/core/components/BookingTime.vue';
import { CreateBooking } from '@/models/bookings';
import moment from 'moment';
import { BookingTimeDisplay, CREATE_BOOKING_DATE_FORMAT } from '@/utils/constants';
import BookingMixin from '../mixins/BookingDateMixin';

export default BookingMixin.extend({
  data() {
    return {
      loading: false,
      start_date: '',
      start_time: '',
      end_date: '',
      selected_date: false,
      time_display: BookingTimeDisplay.END,
      booking: {} as CreateBooking,
      date: '',
      not_available_dates: [] as string[],
    };
  },

  components: {
    NavigationFooter,
    BookingTime,
  },

  created() {
    this.$store.commit(MUTATIONS.SET_HEADER, { title: this.$t('bookings.headers.end_date'), subtitle: '' });
    this.booking = this.$store.getters[GETTERS.GET_CREATE_BOOKING];
    this.end_date = moment(this.booking.endDate ?? '', CREATE_BOOKING_DATE_FORMAT).format('YYYY-MM-DD');
    this.start_date = moment(this.booking.startDate ?? '', CREATE_BOOKING_DATE_FORMAT).format('YYYY-MM-DD');
    this.start_time = this.booking.startTime ?? '';

    this.date = moment(this.booking.endDate ?? moment(), CREATE_BOOKING_DATE_FORMAT).format('YYYY-MM-DD');
    this.selected_date = !!this.date;
    this.date = this.date || this.minDate;
    this.date = moment.max([moment(this.date), moment(this.minDate)]).format('YYYY-MM-DD');
  },

  methods: {
    async onDateChanged(): Promise<void> {
      this.selected_date = true;
      const period = moment(this.date).format('YYYY-MM');
      await this.setDatePickerBookingDatesColor(
        period,
        this.booking.startDate ?? '',
        moment(this.date).format(CREATE_BOOKING_DATE_FORMAT),
      );
      await this.setDatePickerColor(period, this.getMonthlyBookings(period));
    },

    onDateSelected(): void {
      this.booking.endDate = moment(this.date, 'YYYY-MM-DD').format(CREATE_BOOKING_DATE_FORMAT);
      this.$store.commit(MUTATIONS.SET_CREATE_BOOKING, this.booking);
      const period = moment(this.date).format('YYYY-MM');
      this.$store.commit(MUTATIONS.SET_MONTHLY_BOOKING, this.getMonthlyBookings(period));
      this.$router.push('/booking/end-time');
    },
  },

  computed: {
    minDate(): string {
      return moment().isAfter(this.start_date)
        ? moment().format('YYYY-MM-DD')
        : moment(this.start_date).format('YYYY-MM-DD');
    },

    confirmDateDisabled(): boolean {
      return !this.date || moment(this.booking.startDate, CREATE_BOOKING_DATE_FORMAT).isAfter(this.date);
    },
  },
});
